/** Upper bound the ai-service accepts for the text of a company extraction request. */
export const COMPANY_EXTRACTION_MAX_LENGTH = 2000

export interface CompanyExtractionResponse {
  companies: string[]
  count: number
}
